import { render, staticRenderFns } from "./MarketplaceForm.vue?vue&type=template&id=4925cc58&scoped=true"
import script from "./MarketplaceForm.vue?vue&type=script&lang=js"
export * from "./MarketplaceForm.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceForm.vue?vue&type=style&index=0&id=4925cc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925cc58",
  null
  
)

export default component.exports